// Calculate the median of a given number array
export const median = (array: number[]): number => {
  if (array.length === 0) return 0

  // Don't mutate the original array
  const sorted = array.slice().sort((a, b) => a - b)
  const mid = Math.floor(sorted.length / 2)

  return sorted.length % 2 !== 0 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2
}
